const Statements = [];
const setStatement = (state = Statements, action) => {
    if(action.type === "SET_STATEMENTS"){
        state =  action.statements
        
    }
    return state;
}

export default setStatement;